import * as React from 'react';

export interface CustomEditRendererState {
    isEditMode: boolean;
    isDisabled: any;
}

var self;
export class GridButtonCACTClearRenderer extends React.Component<any, CustomEditRendererState> {
    constructor(props: any) {
        super(props);

        this.state = {
            isEditMode: false,
            isDisabled: null,
        };
        self = this;
    }

    componentDidMount() {
        this.setState({ isDisabled: false });

    }
    setSaveButtonDisabled(flag) {
        this.setState({ isDisabled: flag });
    }

  

    componentWillReceiveProps(nextprops: any) {


    }
    clearCAValues(e) {
        if(this.props.column.colDef.headerName == 'Clear CA')
        {
            this.props.node.setDataValue('O2Setpoint', '');
            this.props.node.setDataValue('O2SetpointMin', '');
            this.props.node.setDataValue('O2SetpointMax', '');
            this.props.node.setDataValue('CO2Setpoint', '');
            this.props.node.setDataValue('CO2SetpointMin', '');
            this.props.node.setDataValue('CO2SetpointMax', '');
        }
        if(this.props.column.colDef.headerName == 'Clear CT')
        {
            this.props.node.setDataValue('CTDays', '');
            this.props.node.setDataValue('USDAMaxTemperature', '');
            this.props.node.setDataValue('postCTTemperature', '');
            this.props.node.setDataValue('postCTTemperatureDeviation', '');
            this.props.node.setDataValue('postCTVentSetting', '');
        }
    }

    public render() {
        return <div>
            <button type='button' className='btn btn btn-primary clearCACTButton' onClick={this.clearCAValues.bind(this)}><span className='fas fa-eraser'></span></button>
            
        </div>;
    }
}